import { WIKI_CATEGORIES } from 'mk/autogenerated/wikiCategories';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { url, ID_RE, SLUG_RE } from 'mk2/helpers/urls';

const ARTICLE_ID = `:articleId(${ID_RE})`;
const CATEGORY_SLUG = `:categorySlug(${SLUG_RE})`;
const ARTICLE_SLUG = `:articleSlug(${SLUG_RE})`;

export const wikiUrl = '/wiki/';
export const wikiArticleUrl = `/:categorySlug(${WIKI_CATEGORIES.map((wc) => wc.slug).join('|')})/${ARTICLE_SLUG}/`;
export const wikiArticleEditUrl = `/wiki/article/edit/${ARTICLE_ID}/`;
export const wikiArticleCreateUrl = '/wiki/article/new/';
export const wikiAddExperienceUrl = `/wiki/article/${CATEGORY_SLUG}/${ARTICLE_SLUG}/add-experience/`;

export const wikiFaqContactUrl = url(wikiArticleUrl, {
    categorySlug: 'faq',
    articleSlug: {
        201: 'prevadzkovatel-a-fakturacne-udaje',
        202: 'provozovatel-a-fakturacni-udaje',
        207: 'contact-and-invoicing-data',
    }[ACTIVE_SERVER_ID],
});
